import { setActiveEquipmentCode } from "../../../../common-deprecated/redux/actions/UtilActions";
import type { EquipmentCategoryType } from "../utils/types";
import type { EquipmentV2DispatchType } from "../redux/store";
import { useEquipmentV2Selector } from "../redux/store";
import { trackEvent } from "../../../../common-deprecated/utils/tracking";
import { getEquipmentComponentName } from "../utils/tracking";
import { useDispatch } from "../../../../shared-logic/redux/store";

type useEquipmentContentSliderType = {
    activeCategory?: EquipmentCategoryType;
    filteredItems?: EquipmentCategoryType["items"];
    switchEquipment: (itemCode: string) => void;
};

const useEquipmentContentSlider = (categories: EquipmentCategoryType[]): useEquipmentContentSliderType => {
    const activeItemCode = useEquipmentV2Selector((state) => state.utils.activeEquipmentCode);
    const colourId = useEquipmentV2Selector((state) => state.equipment.selectedCar.colourId);
    const componentName = useEquipmentV2Selector((state) => state.commonSettings.component);
    const dispatch = useDispatch<EquipmentV2DispatchType>();

    const activeCategory = categories.find((item) => item.code === activeItemCode);
    const filteredItems = activeCategory?.items.filter(
        (item) => item.availableForColourIds.length < 1 || item.availableForColourIds.includes(colourId || ""),
    );

    return {
        activeCategory,
        filteredItems,
        switchEquipment: (itemCode: string) => {
            trackEvent({
                component: getEquipmentComponentName(componentName),
                group: "new-cars",
                action: "click-tab",
                label: categories.find((item) => item.code === itemCode)?.title || "",
            });
            dispatch(setActiveEquipmentCode(itemCode));
        },
    };
};

export default useEquipmentContentSlider;
